import { Button, Flex, Text, Tooltip } from '@modusign/design-system';

interface InPersonCompleteFooterBarProps {
  isLastInPersonSigner?: boolean;
  onEndSigningClick: () => void;
  onKeepSigningClick: () => void;
}

export default function InPersonCompleteFooterBar({
  isLastInPersonSigner,
  onEndSigningClick,
  onKeepSigningClick,
}: InPersonCompleteFooterBarProps) {
  return (
    <Flex alignItems="center" bg="darkGray700" gap={3} justifyContent="center" p={4} width="100%">
      {!isLastInPersonSigner && (
        <Tooltip
          content={<Text>다른 서명자의 대면서명을 바로 진행할 수 있습니다.</Text>}
          mode="day"
        >
          <Button height={48} width={180} onClick={onKeepSigningClick}>
            계속 진행하기
          </Button>
        </Tooltip>
      )}
      <Button height={48} variant="primary" width={180} onClick={onEndSigningClick}>
        진행자 확인
      </Button>
    </Flex>
  );
}
